import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	restrictedBoard: {
		id: 'backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.restricted-board',
		defaultMessage: 'Restricted Board',
		description:
			'Text shown to users in the sprint header when the sprint is from a privated board',
	},
	boardIconLabel: {
		id: 'backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.board-icon-label',
		defaultMessage: 'Origin Board',
		description: 'label for the board icon in the sprint header',
	},
	noPermissionFlagHeader: {
		id: 'backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.no-permission-flag-header',
		defaultMessage: "You don't have permission to access this project",
		description: 'Header text for flag shown when user tries to access a restricted project',
	},
	noPermissionFlagBody: {
		id: 'backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.no-permission-flag-body',
		defaultMessage: 'Speak to your Jira admin or Project admin to get access',
		description: 'Body text for flag shown when user tries to access a restricted project',
	},
	originBoardLink: {
		id: 'backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.origin-board-link',
		defaultMessage: 'from {boardName}',
		description: 'Link to the board from which a sprint was created',
	},
});
